/**
 * Created by agengmaulana on 4/28/17.
 */
import React from 'react'
import Comment_Profile_Image from '../comment_profile_image/comment_profile_image'
import Comment_Share from '../comment_share/comment_share'
import Comment_Like_Button from '../comment_like_button/comment_like_button'
import Comment_Article_reply from './comment_article_reply'
import Comment_Username from '../comment_username/comment_username'
import styles from './../../assets/css/comment.css'
import  './../../assets/css/comment.css'
// var $ = require("jquery");

// @observer
export default class Comment_Article extends React.Component {

    render(){

        const post = {
            // position: 'relative',
            important: true
        }
        const uaBreak = /iPhone|iPad|iPod/i.test(navigator.userAgent)?'break-all':'normal'
        const margin = {
            // margin : "0px 0px 0px 110px",
            // important: true
            wordBreak:uaBreak
        }

        return(

            <article key={this.props.data.id}>
                <Comment_Profile_Image mr10="true" photo={this.props.data.author.photo} nickname={this.props.data.author.name}/>
                <div className={styles.cmt_label_pilred+' '+styles.cmt_fr}>
                    <i className={styles.icon+' dk_icon-check-square cmt_check'}></i> Komentar Pilihan
                </div>
                <Comment_Username date="0" nickname={this.props.data.author.name} mb10="true" verified_user={typeof this.props.datastoresVerified[this.props.data.author.uniqueid] !== 'undefined'?this.props.datastoresVerified[this.props.data.author.uniqueid]:false}/>
                <span className={styles.cmt_box_text + ' ' + styles.cmt_dk_komen} style={margin}>
                    {
                        unescape(this.props.data.content.substring(0,125))
                    }
                    { unescape(this.props.data.content.length) >= 125 ? '... ' : ''}
                    { unescape(this.props.data.content.length) >= 125 ? <Comment_Article_reply id={this.props.data.id} parent_id={this.props.data.parent} datFunction={this.props.datFunction} comarticle="1" /> : '' }
                                <div className={styles.cmt_dk_action} style={post}>
                       <Comment_Like_Button parent_id={this.props.data.parent}  id={this.props.data.id} status_like={this.props.data.liker.length}
                                             dataStore={this.props.datFunction} like={this.props.data.like_count} />
                       <Comment_Article_reply id={this.props.data.id} parent_id={this.props.data.parent} datFunction={this.props.datFunction} comarticle="0" />
                                    {/*<a href="javascript:void(0);" className={styles.mr15 +' '+styles.dk_balas} onClick={this.testing(this.props.data.id)}  >Balas</a>*/}
                       Bagikan:    <Comment_Share content={this.props.data.content} id={this.props.data.id} datFunction={this.props.datFunction} />
                    </div>
                </span>
            </article>
        )
    }


}



// WEBPACK FOOTER //
// ./static/src/component/comment_article/comment_article.js